import { readStartPage } from "./start-data";

export function getStartPage({
  data,
  signal,
}: {
  data: { href: string };
  signal?: AbortSignal | undefined;
}) {
  return readStartPage({ href: data.href, signal });
}
